<template>
  <header-layout>
    <section id="password-reset">
      <div class="container">
        <div class="columns">
          <div class="column is-half is-offset-one-quarter">
            <form class="form">
              <h1 class="title">Set your new password</h1>
              <p class="content">Remember to choose a strong one!</p>

              <div v-if="errorMessage" class="notification is-danger has-text-center">
                {{ errorMessage }}
              </div>

              <div class="field">
                <label class="label">New password</label>
                <div class="control">
                  <input class="input" type="password" v-model="password">
                </div>
              </div>
              <div class="field">
                <label class="label">Confirm password</label>
                <div class="control">
                  <input class="input" type="password" v-model="passwordConfirm">
                </div>
              </div>
              <div class="columns">
                <div class="column is-half is-offset-one-quarter">
                  <button class="button is-fullwidth" :class="{ 'is-loading': isSending }" type="submit" @click.prevent="send()">Send</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </header-layout>
</template>

<script>
import Utils from '@/utils/Utils'

import HeaderLayout from '@/layouts/HeaderLayout'

export default {
  components: {
    HeaderLayout
  },

  methods: {
    send () {
      if (this.isSending) {
        return false
      }

      const password = this.password
      const passwordConfirm = this.passwordConfirm

      if (!password.length || !passwordConfirm.length) {
        this.errorMessage = `Fields can't be empty`
        return false
      }

      if (password.length < 6 || passwordConfirm.length < 6) {
        this.errorMessage = `Password should be at least 6 characters long`
        return false
      }

      if (password !== passwordConfirm) {
        this.errorMessage = `Passwords don't match`
        return false
      }

      this.isSending = true

      this.$store.dispatch('resetPassword', { password, passwordConfirm })
        .then(res => Utils.setApiToken(res.apitoken, res.user))
        .then(() => this.$router.push(this.$route.params.redirect || 'dashboard'))
    }
  },

  created () {
    const isReset = this.$route.query.reset === 'true' || false
    const token = this.$route.query.token

    if (isReset && token) {
      Utils.setApiToken(token)
    }
  },

  data () {
    return {
      isSending: false,
      password: '',
      passwordConfirm: '',
      errorMessage: null
    }
  }
}
</script>

<style lang="scss">

#password-reset {
  margin: 6rem 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/PasswordResetPage.vue